module.exports = __webpack_public_path__ + "img/net.ee0afd0.svg";